import { ProgCss } from "./ProgCss.Generated";
import { AssertNotNull } from "./tools";

export function InitColumnTree(scopeEl: HTMLElement) {
    for (const el of scopeEl.querySelectorAll(`form .${ProgCss.ColumnTree_row}[data-select-node-uri]`)) {
        el.addEventListener(
            "click",
            e => {
                if (e.target instanceof Element && !e.defaultPrevented && !e.target.matches("a[href], a[href] *, button, button *")) {
                    e.preventDefault();

                    const inputEl = document.createElement("input");
                    inputEl.type = "hidden";
                    inputEl.name = AssertNotNull(el.getAttribute("data-select-node-uri"));

                    const form = AssertNotNull(e.target.closest("form"));
                    form.append(inputEl);
                    form.requestSubmit();
                }
            });
    }
}
